import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../../../contexts/DialogContext';
import useDeleteGitLabInstance from '../../../../hooks/api/settings/integrations/useDeleteGitLabInstance';
import { BUTTON_SIZE, FormGroup, LabeledTextInput } from '../../../generic';
import { LoaderButton } from '../../../generic/Button';
import type { GitLabInstance } from '../../../../../shared/settings/gitlab';

type Props = {
  instance: GitLabInstance;
};

const GitLabInstanceRow: VoidFunctionComponent<Props> = ({ instance }) => {
  const dialogContext = useDialogContext();
  const { mutate: deleteInstance, isPending: isDeleting } = useDeleteGitLabInstance(instance.id);

  const onDelete = () => {
    dialogContext.onConfirm({
      title: 'Delete GitLab instance',
      body: <p>Are you sure you want to delete this GitLab instance?</p>,
      onConfirm: () => deleteInstance(),
    });
  };

  return (
    <FormGroup direction="row" spacing="xl" baselineAlignment>
      <LabeledTextInput
        labelVariant="legacy"
        label="Name"
        value={instance.name}
        isDisabled
      />
      <LabeledTextInput
        labelVariant="legacy"
        label="Base URL"
        value={instance.baseUrl}
        isDisabled
      />
      <LabeledTextInput
        labelVariant="legacy"
        label="Client ID"
        value={instance.clientId}
        isDisabled
      />
      <LoaderButton
        type="error"
        isLoading={isDeleting}
        size={BUTTON_SIZE.MEDIUM}
        onClick={onDelete}
      >
        Remove
      </LoaderButton>
    </FormGroup>
  );
};

export default GitLabInstanceRow;
